import { StzButton, StzLoader } from '@staizen/graphene-react';
import { APP_LOCALE } from 'config/configureI18n';
import { cx } from 'emotion';
import React, { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MARKET_DATA_URL, TAG } from './contants';
import { styles } from './styles';
import { getCurrentUTCDateInISO } from 'utils/dateTimeUtils';
import { useSaveTermsAndConditions } from 'features/onboarding/hooks/useSaveTermsAndConditions';

interface OnboardingMarketDataProps {
  onBack: () => void;
  onNext: () => void;
  onDecline: (value: string) => void;
}

export function OnboardingMarketData({ onBack, onNext, onDecline }: OnboardingMarketDataProps): ReactElement {
  const { t } = useTranslation(TAG);
  const { saveTermsAndConditions, isSavingTermsAndConditions } = useSaveTermsAndConditions(onNext);

  const onAcceptClick = (): void => {
    saveTermsAndConditions([{
      name: t('marketData.terms.name'),
      version: t('marketData.terms.version'),
      timestamp: getCurrentUTCDateInISO(),
    }]);
  };

  const renderDescriptions = (): ReactElement => {
    const descriptions: string[] = t(`${TAG}:termsOfUse`, {
      returnObjects: true,
    });
    return (
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <Trans
            i18nKey={t(`${TAG}:marketData.content`, { marketDataUrl: MARKET_DATA_URL })}
            components={{
              linkPolicy: <a href={MARKET_DATA_URL}>marketDataUrl</a>,
            }}
          />
        </div>
        {descriptions.map(
          (item): ReactElement => (
            <div key={item} className={styles.content}>
              {item}
            </div>
          ),
        )}
      </div>
    );
  };
  return (
    <div className="stz-card">
      <div className="stz-card-header">
        <div className={cx('stz-card-title', styles.title)}>{t(`${TAG}:marketData.title`)}</div>
      </div>
      <div className="stz-card-body">{renderDescriptions()}</div>
      <div className={styles.actionWrapper}>
        <StzButton variant="text" onClick={onBack}>
          <span>{t(`${APP_LOCALE}:buttons.back`)}</span>
        </StzButton>
        <div className={styles.actionRight}>
          <StzButton preset="secondary" onClick={(): void => onDecline(t(`${TAG}:marketData.title`))}>
            <span>{t(`${APP_LOCALE}:buttons.decline`)}</span>
          </StzButton>
          <StzButton onClick={onAcceptClick} disabled={isSavingTermsAndConditions}>
            <span>{isSavingTermsAndConditions ? <StzLoader type="dots" /> : t(`${APP_LOCALE}:buttons.accept`)}</span>
          </StzButton>
        </div>
      </div>
    </div>
  );
}
